import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GET_INSIDE_COLLECTION_DATA,
} from "../../DAM_API/urls";
import ImageGridSecondVersion from "../../Common/Designs/CommonAssets";
import { selectRangeByUUID } from "../folder/Innerfolder";
import { CommonSvg } from "../../Common/SVG";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";
import Axios from "../../../utils/Axios";

const InsideCollectionView = () => {
  const { id } = useParams();
  const [collectionData, setCollectionData] = useState();
  const [collectionAssets, setCollectionAssets] = useState([]);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [filterState, setFilterState] = useState({});
  const { startDownload } = useDownloadAssets();

  const downloadHandler = async (data) => {
    try {
      var _data = {
        fileId: collectionAssets
          .filter((item) => item?.isSelected)
          ?.map((item) => item?.assetId),
        folderId: [],
        files: collectionAssets?.filter((i) => i?.isSelected)?.map((i) => i),
        email: "",
      };
      const response = await startDownload(_data);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        const result = await Axios.get(
          `${GET_INSIDE_COLLECTION_DATA}?collectionId=${id}&searchKeyword=${
            filterState.searchInput ?? ""
          }`,
        );
        setCollectionData(result?.data?.data);
        setCollectionAssets(result?.data?.data?.damFileDtos);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [filterState, id]);
  return (
    <Fragment>
      <div
        className="container "
        style={{
          marginTop: "80px",
        }}
      >
        {" "}
        <div className="d-flex justify-content-between">
          {" "}
          <h2>Collection</h2>
          {/* <div className="d-flex justify-content-end">
            {(sharedData?.files?.some((item) => item?.isSelected) ||
              sharedData?.folders?.some((item) => item?.isSelected)) && (
              <div>
                {" "}
                <button className="Primary-Button" onClick={downloadHandler}>
                  Download
                </button>
              </div>
            )}
          </div> */}
          {collectionAssets?.some((item) => item?.isSelected) && (
            <div>
              {" "}
              <button className="Primary-Button" onClick={downloadHandler}>
                Download
              </button>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end">
          {" "}
          <div className="d-flex search-box align-items-center">
            <div
              style={{
                marginLeft: "0.5rem",
              }}
            >
              {CommonSvg.searchIconSvg}
            </div>
            <input
              type="search"
              placeholder="Search Assets"
              value={filterState?.searchInput || ""}
              onChange={(e) => {
                setFilterState((prev) => ({
                  ...prev,
                  searchInput: e.target.value,
                }));
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "1rem",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          {collectionAssets?.map((item) => (
            <ImageGridSecondVersion
              Data={item}
              EllipseActions={CommonSvg.downloadIconsSvg}
              HandleSelect={(value) => {
                if (value?.Key === 3) {
                  const returnedValueData = selectRangeByUUID(
                    collectionAssets,
                    prevIndexSelected,
                    item?.assetId,
                    "assetId",
                  );

                  setCollectionAssets(returnedValueData);
                }

                if (value?.Key === 1) {
                  setPrevIndexSelected(item?.assetId);
                  setCollectionAssets((prev) =>
                    prev.map((_item) =>
                      _item?.assetId === item?.assetId
                        ? { ..._item, isSelected: !item?.isSelected }
                        : { ..._item, isSelected: false },
                    ),
                  );
                }

                if (value?.Key === 2) {
                  setPrevIndexSelected(item?.assetId);

                  setCollectionAssets((prev) =>
                    prev.map((_item) =>
                      _item?.assetId === item?.assetId
                        ? { ..._item, isSelected: !item?.isSelected }
                        : { ..._item },
                    ),
                  );
                }
              }}
              isSelected={item.isSelected}
            />
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default InsideCollectionView;
